<template>
	<HookCustom  componente="maintenance" />
</template>

<script>
	import HookCustom from '@/components/Porlet/PorletHookCustom.vue'
	
	export default {
		name: 'Maintenance',
		components: {
			HookCustom
		}
	}
</script>